import React from 'react'
import { BaseLayout } from 'src/layouts'
import styles from './styles.module.scss'
import { Container } from 'src/elements'
import { useAuthorIndex } from 'src/state'
import { WEBSITE } from 'src/consts'
import { NewsArticleItem } from 'src/pages/NewsArticles/components/NewsArticleItem'
import AuthorItem from 'src/pages/Author/components/AuthorItem'

export type AuthorListDetailsProps = {
  slug: string
}

export const AuthorDetails = ({ slug }: AuthorListDetailsProps) => {
  const { fullName, bio, shortDescription, email, image, news } =
    useAuthorIndex({ slug }).data
  const imageUrl = image.data.attributes.url

  return (
    <div className={styles.container}>
      <Container className={styles.authorDetailsContainer}>
        <div className={styles.authorItem}>
          <AuthorItem
            author={{
              fullName,
              bio,
              shortDescription,
              email,
              image: imageUrl,
            }}
            alwaysShowBio={true}
            isLink={false}
          />
        </div>
        <h1 className={styles.articlesTitle}>Articles by {fullName}</h1>
        <div className={styles.articleContainer}>
          {news.data.map(article => (
            <div key={article.id} className={styles.newsArticle}>
              <NewsArticleItem key={article.id} newsArticle={article} />
            </div>
          ))}
        </div>
      </Container>
    </div>
  )
}

const AuthorDetailsLayout = ({ children, slug }) => {
  const { seo } = useAuthorIndex({ slug }).data
  return (
    <BaseLayout
      scrollInContent
      seo={{
        title: seo?.metaTitle || 'Coin360 Author',
        description: seo?.metaDescription || 'One of the authors at Coin360',
        canonical: `${WEBSITE}/author/${slug}`,
      }}
    >
      {children}
    </BaseLayout>
  )
}

AuthorDetails.getLayout = AuthorDetailsLayout
